// An empty editable box is invisible without a placeholder, so one is always found
export const emptyPlaceholder = (
  placeholder: string | undefined,
  label: string | undefined,
  fallback: string
): string => placeholder || (label ? `Add ${label.toLowerCase()}` : fallback);
